import { get } from "util/HttpRequest"

export const GET_USERS = async () => {
    return await get({url : "/users"}) 
}